import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { BankingInfo } from '../../../classes/banking-info';
import { NgForm } from '@angular/forms';
import { BankingInfoService } from '../../../services/banking-info.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { CompanyService } from '../../../services/company.service';
import { SimplePageScrollService } from 'ng2-simple-page-scroll';


@Component({
  selector: 'app-banking-info-page',
  templateUrl: './banking-info-page.component.html',
  styleUrls: ['./banking-info-page.component.scss']
})
export class BankingInfoPageComponent implements OnInit {
  bankingInfo: BankingInfo = <BankingInfo>{};
  bankingInfos: BankingInfo[] = [];
  edit: boolean[] = [];
  editing: boolean[] = [];
  sub: any;
  orgId: number;
  adding: boolean;
  isAdmin: boolean;
  error: string = '';
  company: any;
  steps: any;
  incomplete: boolean;
  state: any;
  focus: any[] = [];
  finFocus: boolean = false;
  routeFocus: boolean = false;
  transFocus: boolean = false;
  accFocus: boolean = false;
  noteFocus: boolean = false;
  openRouting: boolean = false;
  openTransit: boolean = false;
  openAccount: boolean = false;
  openNote: boolean = false;
  openRoutingPopups: boolean[] = [];
  openTransitPopups: boolean[] = [];
  openAccountPopups: boolean[] = [];
  openNotePopups: boolean[] = [];
  @ViewChild('bankingRow') private bankingRow: ElementRef;

  constructor(
    private BankingInfoService: BankingInfoService,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private CompanyService: CompanyService,
    private router: Router,
    private simplePageScrollService: SimplePageScrollService
  ) { }

  ngOnInit() {
    this.getBankingInfo();
    this.titleService.setTitle('Banking Information');
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })

  }

  getBankingInfo() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.BankingInfoService.getBankingInfos(this.orgId)
        .subscribe(bankinfos => {
          this.bankingInfos = JSON.parse(bankinfos.banking_informations || '[]');
          this.edit = this.bankingInfos.map(b => {
            return false;
          });
          this.editing = JSON.parse(JSON.stringify(this.edit));
          this.focus = this.bankingInfos.map(b => {
            return {
              finFocus: false,
              routeFocus: false,
              transFocus: false,
              accFocus: false,
              noteFocus: false,
            }
          })
          this.openAccountPopups = this.bankingInfos.map(b => {
            return false;
          })

          this.openNotePopups = this.bankingInfos.map(b => {
            return false;
          })

          this.openRoutingPopups = this.bankingInfos.map(b => {
            return false;
          })

          this.openTransitPopups = this.bankingInfos.map(b => {
            return false;
          })

        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })

      this.getComplete();
    })
  }


  getComplete() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.incomplete = this.steps.slice(0, 3).some(s => {
          console.log(s)
          return !s[2];
        })
        this.state = JSON.parse(company.state);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  addBankingInfo(bankingInfoForm: NgForm) {
    this.adding = true;
    this.error = '';
    if (bankingInfoForm.invalid) {
      return;
    }

    let bankInfoExist = this.bankingInfos.filter(b => {
      return b.fi_account_number == this.bankingInfo.fi_account_number &&
        b.fi_routing_number == this.bankingInfo.fi_routing_number &&
        b.fi_transit_number == this.bankingInfo.fi_transit_number
    }).length > 0;

    if (bankInfoExist) {
      this.error = 'Banking info already added';
      return;
    }
    this.BankingInfoService.addBankingInfo(this.orgId, this.bankingInfo)
      .subscribe(bankinfo => {
        this.adding = false;
        this.getBankingInfo();
        this.bankingInfo = <BankingInfo>{};
        bankingInfoForm.reset();
        if(!this.isAdmin) window.analytics.track("Self-Signup Banking Info Added", {OrgId: this.orgId});
        // Scroll to newly added row
        this.simplePageScrollService.scrollToElement('#bankingRow-0', 0);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
        else {
          console.log(JSON.parse(err._body));
          this.error = JSON.parse(JSON.parse(err._body).flash)[0][1];
          if(!this.isAdmin) window.analytics.track("Self-Signup Banking Info Addition Failed", {OrgId: this.orgId, reason: this.error});
        }
      })
  }

  editBankingInfo(index: number) {
    this.edit[index] = true;
  }

  removeBankingInfo(id: number) {
    this.BankingInfoService.deleteBankingInfo(this.orgId, id)
      .subscribe(bankinfo => {
        this.getBankingInfo();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  complete(id: number, bankingInfoForm: NgForm, bankingInfo: BankingInfo, index: number) {
    this.editing[index] = true;
    this.error = '';
    if (bankingInfoForm.invalid) {
      return;
    }

    let bankInfoExist = this.bankingInfos.filter(b => {
      return b.fi_account_number == bankingInfo.fi_account_number &&
        b.fi_routing_number == bankingInfo.fi_routing_number &&
        b.fi_transit_number == bankingInfo.fi_transit_number &&
        b.id != bankingInfo.id;
    }).length > 0;

    if (bankInfoExist) {
      this.error = 'Banking info already added';
      return;
    }

    this.BankingInfoService.editBankingInfo(this.orgId, id, bankingInfo)
      .subscribe(bankinfo => {
        this.editing[index] = false;
        this.getBankingInfo();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
        else {
          this.error = JSON.parse(JSON.parse(err._body).flash)[0][1];
        }
      })
  }

  showError(ev: string) {
    this.error = ev;
  }

  onClickedOutside(e: any) {
    console.log('Clicked outside:', e);
    if (e.target.className != 'fa fa-question-circle-o') {
      this.openAccount = false;
      this.openNote = false;
      this.openRouting = false;
      this.openTransit = false;
      this.openAccountPopups = this.openAccountPopups.map(r => { return false });
      this.openNotePopups = this.openNotePopups.map(r => { return false });
      this.openRoutingPopups = this.openRoutingPopups.map(r => { return false });
      this.openTransitPopups = this.openTransitPopups.map(r => { return false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/banking-info-page/banking-info-page.component.ts